import { useHandleToast } from "hooks/useHandleToast"

export const useHandleModalResponse = ({
  sendEmails,
  errorSendEmails,
  downloadSucess,
  error,
  loader
}) => {
  useHandleToast({
    sucessCondition: sendEmails && !loader,
    sucessMsg:
      "Cliente, o seu detalhamento de chamadas foi enviado por e-mail com sucesso!",
    errorCondition: errorSendEmails && !loader,
    errorMsg:
      "Cliente, ocorreu um erro ao enviar o seu detalhamento de chamadas por e-mail! Tente novamente dentro de alguns minutos."
  })

  useHandleToast({
    sucessCondition: downloadSucess && !loader,
    sucessMsg:
      "Cliente, o seu detalhamento de chamadas foi baixado com sucesso!",
    errorCondition: error && !loader,
    errorMsg:
      "Cliente, ocorreu um erro em  seu download! Tente novamente dentro de alguns minutos."
  })
}



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/useHandleModalResponse.js